import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    changeFileAction,
    changeXAttrAction,
    changeYAttrAction,
    changeZAttrAction,
    changeGeoAction,
    changeIDAction,
    changeGLChkAction,
    changeGLAction,
    changeWLChkAction,
    changeWLAction,
    changeHeaderNumAction,
    changeFieldNameChkAction,
    changeCsvDataAction,
    changeNewDataAction
} from '../../redux/boring/actions';

const mapStateToProps = state => {
    return {
        file: state.boringReducer.file,
        XAttr: state.boringReducer.XAttr,
        YAttr: state.boringReducer.YAttr,
        ZAttr: state.boringReducer.ZAttr,
        geo: state.boringReducer.geo,
        ID: state.boringReducer.ID,
        GLChk: state.boringReducer.GLChk,
        GL: state.boringReducer.GL,
        WLChk: state.boringReducer.WLChk,
        WL: state.boringReducer.WL,
        headerNum: state.boringReducer.headerNum,
        fieldNameChk: state.boringReducer.fieldNameChk,
        csvData: state.boringReducer.csvData,
        newData: state.boringReducer.newData
    };
};

class CSV extends Component {
    /*★ここから公開版で削除*/
//    constructor(props) {
//        super(props);
//        this.thList = [];
//        this.tbList = [];
//        this.option = [];
//        this.csvData = this.props.csvData;
//        this.fieldNameChk = this.props.fieldNameChk;
//        
//        this.changeFile = this.changeFile.bind(this);
//        this.changeXAttr = this.changeXAttr.bind(this);
//        this.changeYAttr = this.changeYAttr.bind(this);
//        this.changeZAttr = this.changeZAttr.bind(this);
//        this.changeGeo = this.changeGeo.bind(this);
//        this.changeID = this.changeID.bind(this);
//        this.changeGLChk = this.changeGLChk.bind(this);
//        this.changeGL = this.changeGL.bind(this);
//        this.changeWLChk = this.changeWLChk.bind(this);
//        this.changeWL = this.changeWL.bind(this);
//        this.changeHeaderNum = this.changeHeaderNum.bind(this);
//        this.changeFieldNameChk = this.changeFieldNameChk.bind(this);
//        this.createInput = this.createInput.bind(this);
//        
//        if (this.csvData.length)//CSVデータが存在する場合
//            this.createInput();
//    }
//
//    /*
//     * ファイル変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-24
//     */
//    changeFile(e) {
//        let file = e.target.files[0];
//        
//        // CSVファイル以外は処理を止める(タイトル等変わるので修正必要)
//        if(!file.name.match('.csv$')) {
//            alert('CSVファイルを選択してください。');
//            return;
//        }
//        
//        const reader = new FileReader();
//        reader.onload = () => {
//            const res = reader.result;
//            this.csvData = res.split('\n');//改行ごとに配列化
//            
//            this.createInput();
//            this.props.dispatch(changeCsvDataAction(this.csvData));
//            this.props.dispatch(changeFileAction(file.name));
//        };
//        reader.readAsText(file);
//    }
//    
//    /*
//     * 入力値作成
//     * @since hara 2020-09-24
//     */
//    createInput() {
//        this.thList = [];
//        this.tbList = [];
//        this.option = [];
//        
//        const newData = [].concat(this.csvData);//配列をコピー
//        
//        //ヘッダ破棄
//        for(let i = 0; i < this.props.headerNum; i++){
//            newData.shift();
//        }
//        
//        //最初の行はフィールド名falseの場合フィールド名付与
//        if(this.fieldNameChk === false) {
//            let th = '';
//            let length = (String(this.csvData[0])).split(',').length;
//            for(let i = 0; i < length; i++){
//                let str = i === 0 ? 'Field' : ',Field';
//                th += str + (i + 1);
//            }
//            newData.unshift(th);
//        }
//        
//        for(let i = 0; i < 11; i++){
//            //空白行が出てきた場合終了
//            if(newData[i] === '') break;
//            
//            //','ごとに配列化
//            let arrD = (String(newData[i])).split(',');
//            
//            let tdList = [];
//            for(let j = 0; j < arrD.length; j++){
//                if(i === 0) {
//                    this.thList.push(<th key={j}>{arrD[j]}</th>);
//                    this.option.push(<option value={j} key={j}>{arrD[j]}</option>);
//                } else {
//                    tdList.push(<td key={j}>{arrD[j]}</td>);
//                }
//            }
//            this.tbList.push(<tr key={i}>{tdList}</tr>);
//        }
//        
//        this.props.dispatch(changeNewDataAction(newData));
//    }
//    
//    /*
//     * X属性選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeXAttr(e) {
//        this.props.dispatch(changeXAttrAction(e.target.value));
//    }
//
//    /*
//     * Y属性選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeYAttr(e) {
//        this.props.dispatch(changeYAttrAction(e.target.value));
//    }
//    
//    /*
//     * Z属性選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeZAttr(e) {
//        this.props.dispatch(changeZAttrAction(e.target.value));
//    }
//    
//    /*
//     * 地質選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeGeo(e) {
//        this.props.dispatch(changeGeoAction(e.target.value));
//    }
//
//    /*
//     * ID選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeID(e) {
//        this.props.dispatch(changeIDAction(e.target.value));
//    }
//    
//    /*
//     * 孔口標高チェック変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-11-06
//     */
//    changeGLChk(e) {
//        this.props.dispatch(changeGLChkAction(e.target.checked));
//    }
//    
//    /*
//     * 孔口標高選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-11-06
//     */
//    changeGL(e) {
//        this.props.dispatch(changeGLAction(e.target.value));
//    }
//    
//    /*
//     * 地下水位チェック変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-11-06
//     */
//    changeWLChk(e) {
//        this.props.dispatch(changeWLChkAction(e.target.checked));
//    }
//    
//    /*
//     * 地下水位選択変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-11-06
//     */
//    changeWL(e) {
//        this.props.dispatch(changeWLAction(e.target.value));
//    }
//    
//    /*
//     * 破棄するヘッダ行数入力変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-09
//     */
//    changeHeaderNum(e) {
//        //入力値確認(小数入られないよう修正必要)
//        let val = 0 < e.target.value ? e.target.value : 0;
//        this.props.dispatch(changeHeaderNumAction(val));
//    }
//    
//    /*
//     * 最初の行はフィールド名チェック変更
//     * @param {Event} e イベント情報
//     * @since hara 2020-09-25
//     */
//    changeFieldNameChk(e) {
//        this.fieldNameChk = e.target.checked;
//        this.props.dispatch(changeFieldNameChkAction(this.fieldNameChk));
//        this.createInput();
//    }

    render() {
        return (
            {/*
            <div>
                <div className='l-row'>
                    <label>ファイル：</label>
                    <label className='sBtn'><input type='file' onChange={e => this.changeFile(e)} accept='.csv' />参照</label>
                    <p className="l-mlM">{this.props.file}</p>
                </div>

                <fieldset className='Unit l-mtS'>
                    <legend>ポイント</legend>
                    <table className='l-table'>
                        <tbody>
                            <tr>
                                <td><label>X属性：</label></td>
                                <td><select className='selectM' value={this.props.XAttr} onChange={this.changeXAttr}>{this.option}</select></td>
                                <td><label>Y属性：</label></td>
                                <td><select className='selectM' value={this.props.YAttr} onChange={this.changeYAttr}>{this.option}</select></td>
                            </tr>
                            <tr>
                                <td><label>Z属性：</label></td>
                                <td><select className='selectM' value={this.props.ZAttr} onChange={this.changeZAttr}>{this.option}</select></td>
                                <td><label>地質：</label></td>
                                <td><select className='selectM' value={this.props.geo} onChange={this.changeGeo}>{this.option}</select></td>
                            </tr>
                            <tr>
                                <td><label>ID：</label></td>
                                <td><select className='selectM' value={this.props.ID} onChange={this.changeID}>{this.option}</select></td>
                            </tr>
                            <tr>
                                <td>
                                    <input id='boringCsv_GLChk' className='check' type='checkbox' onChange={this.changeGLChk} defaultChecked={this.props.GLChk} />
                                    <label htmlFor='boringCsv_GLChk'>孔口標高：</label>
                                </td>
                                <td><select className={this.props.GLChk ? 'selectM' : 'selectM disabled'} value={this.props.GL} onChange={this.changeGL}>{this.option}</select></td>
                                <td className='l-blank'>
                                    <input id='boringCsv_WLChk' className='check' type='checkbox' onChange={this.changeWLChk} defaultChecked={this.props.WLChk} />
                                    <label htmlFor='boringCsv_WLChk'>地下水位：</label>
                                </td>
                                <td><select className={this.props.WLChk ? 'selectM' : 'selectM disabled'} value={this.props.WL} onChange={this.changeWL}>{this.option}</select></td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>

                <fieldset className='Unit l-mtS'>
                    <legend>レコードオプション</legend>
                    <label>破棄するヘッダ行数：</label>
                    <input className='textS' type='text' onBlur={this.createInput} onChange={this.changeHeaderNum} value={this.props.headerNum} />
                    <span className='l-blank'>
                        <input id='boringCsv_fieldNameChk' className='check' type='checkbox' onChange={this.changeFieldNameChk} defaultChecked={this.props.fieldNameChk} />
                        <label htmlFor='boringCsv_fieldNameChk'>最初の行はフィールド名</label>
                    </span>
                </fieldset>

                <fieldset className='Unit l-mtS'>
                    <legend>サンプル</legend>
                    <div className='BoringSampleTWrap' style={{overflow: 'scroll'}}>
                        <table className='autoTable'>
                            <thead>{this.thList}</thead>
                            <tbody>{this.tbList}</tbody>
                        </table>
                    </div>
                </fieldset>
            </div>
            */}
        );
    }
    /*★ここまで公開版で削除*/
}

export default connect(mapStateToProps)(CSV);
